import { render } from "./ImprinterNameForm.vue?vue&type=template&id=23da7c69"
import script from "./ImprinterNameForm.vue?vue&type=script&lang=js"
export * from "./ImprinterNameForm.vue?vue&type=script&lang=js"

import "./ImprinterNameForm.vue?vue&type=style&index=0&id=23da7c69&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__